var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classesFather,style:({ width: _vm.sizeWidth + 'px', height: _vm.sizeHeight + 'px' })},[_c('b-img',{class:_vm.classes,attrs:{"src":_vm.url,"fluid":"","alt":_vm.altText ? _vm.altText : ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }